import React from "react";
import { Route } from "react-router-dom";
import AddProject from "../views/AddProject";
import ViewProjects from "../views/ViewProjects";
import AddContractor from "../views/Masters/AddContractor";
import ViewContractor from "../views/Masters/Views/ViewContractor";
import AddTransporter from "../views/Masters/AddTransporter";
import AddCompany from "../views/Masters/AddCompany";
import ViewCompany from "../views/Masters/Views/ViewCompany";
import ViewItems from "../views/Masters/Views/ViewItems";
import AddItemCategory from "../views/Masters/AddItemCategory";
import ViewItemCategory from "../views/Masters/Views/ViewItemCategory";
import AddWorkItem from "../views/Masters/AddWorkItem";
import ViewWorkItems from "../views/Masters/Views/ViewWorkItem";
import AddVendorCategory from "../views/Masters/AddVendorCategory";
import ViewVendorCategory from "../views/Masters/Views/ViewVendorCategory";
import AddStore from "../views/Masters/AddStore";
import ViewStore from "../views/Masters/Views/ViewStore";
import AddVendor from "../views/Masters/AddVendor";
import AddCustomer from "../views/Masters/AddCustomer";
import ViewTransporters from "../views/Masters/Views/ViewTransporter";
import AddItem from "../views/Masters/AddItems";
import ViewVendor from "../views/Masters/Views/ViewVendor";
import ViewCustomer from "../views/Masters/Views/ViewCustomer";
import ViewProjectCategories from "../views/Masters/Views/ViewProjectCategories";
import AddProjectCategory from "../views/Masters/AddProjectCategory";
import AddVendorStore from "../views/Masters/AddVendorStore";
import ViewVendorStore from "../views/Masters/Views/ViewVendorStore";
import AddCustomerStore from "../views/Masters/AddCustomerStore";
import ViewCustomerStore from "../views/Masters/Views/ViewCustomerStore";


const MasterRoutes = [
    <Route path="projects/add/:id?" element={<AddProject />} />,
    <Route path="projects/view" element={<ViewProjects />} />,
    <Route path="vendors/add/:id?" element={<AddVendor />} />,
    <Route path="vendors/view" element={< ViewVendor />} />,
    <Route path="customers/add/:id?" element={<AddCustomer />} />,
    <Route path="customers/view" element={<ViewCustomer />} />,
    <Route path="contractors/add/:id?" element={< AddContractor />} />,
    <Route path="contractors/view" element={< ViewContractor />} />,
    <Route path="transporters/add/:id?" element={<AddTransporter />} />,
    <Route path="transporters/view" element={<ViewTransporters />} />,
    <Route path="company/add/:id?" element={<AddCompany />} />,
    <Route path="company/view" element={<ViewCompany />} />,

    <Route path="categories/view" element={<ViewProjectCategories />} />,
    <Route path="categories/add/:id?" element={<AddProjectCategory />} />,
    <Route path="items/add/:id?" element={<AddItem />} />,
    <Route path="items/view" element={<ViewItems />} />,

    <Route path="itemcategory/add/:id?" element={<AddItemCategory />} />,
    <Route path="itemcategory/view" element={<ViewItemCategory />} />,

    <Route path="workitems/add/:id?" element={<AddWorkItem />} />,
    <Route path="workitems/view" element={<ViewWorkItems />} />,
    <Route
        path="vendorcategory/add/:id?"
        element={<AddVendorCategory />}
    />,
    <Route path="vendorcategory/view" element={<ViewVendorCategory />} />,

    <Route path="store/add/:id?" element={<AddStore />} />,
    <Route path="store/view" element={<ViewStore />} />,

    <Route path="vendorstore/add/:id?" element={<AddVendorStore />} />,
    <Route path="vendorstore/view" element={<ViewVendorStore />} />,
    <Route path="customerstore/add/:id?" element={<AddCustomerStore />} />,
    <Route path="customerstore/view" element={<ViewCustomerStore />} />
];

export default MasterRoutes;
